import type { AggregateProgressRow } from '@/features/operation-package/-components/AggregateProgressTable/types';
import type { ListDeviceInventoryPatternGenerationsOutput } from '@/lib/api/orpc/contracts/it-operation-core-device-inventory';
import type { DeviceInventoryInstanceTagSummary } from './type';

/**
 * サーバー集計の固まり（タグ）サマリを集計テーブルのグループ行へ変換する。
 * target / step 件数はグループ行では参照されない（進捗は groupCompletedCount /
 * groupTotalCount、見出しは tag / anchorDate を使う）ためプレースホルダで埋める。
 * セルフレポート俯瞰一覧（`SelfReportOperation`）と同じ流儀。
 */
export function mapTagSummaryToGroupRow(summary: DeviceInventoryInstanceTagSummary): AggregateProgressRow {
  return {
    id: `group:${summary.id}`,
    target: {
      targetType: '',
      targetId: '',
      targetName: ''
    },
    anchorDate: summary.anchorDate ?? '',
    tag: {
      id: summary.id,
      name: summary.name
    },
    completedOperationStepCount: 0,
    totalOperationStepCount: 0,
    groupCompletedCount: summary.completedCount,
    groupTotalCount: summary.totalCount
  };
}
export type DeviceInventoryPatternGeneration = 'v1' | 'v2';

/** pattern-generations レスポンスを patternId 引きの Map にする */
export function toPatternGenerationMap(output: ListDeviceInventoryPatternGenerationsOutput): ReadonlyMap<string, DeviceInventoryPatternGeneration> {
  return new Map(output.items.map(i => [i.patternId, i.generation]));
}